// // QRCodeComponent.js
// import React, { Component } from "react";
// import { Avatar, Button, QRCode } from "antd"; // นำเข้า library qrcode.react
// import "./QRCodeComponent.css";
// import { CloseCircleFilled, CloudDownloadOutlined, ReloadOutlined } from "@ant-design/icons";
// import moment from "moment";
// import Logo from "../assets/images/logo/payeasy1.png";
// import config from "../config/app.config";

// class QRCodeComponent extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       timeLeft: 60, // 300 วิ = 5 นาที // ทดสอบ 60 วิ
//       isExpired: false,
//     };
//     this.timer = null;
//     // สร้าง ref เพื่อเข้าถึง element ของ QR Code canvas
//     this.qrCodeRef = React.createRef();
//   }

//   componentDidMount() {
//     this.timer = setInterval(() => {
//       this.setState((prevState) => {
//         if (prevState.timeLeft > 0) {
//           return { timeLeft: prevState.timeLeft - 1 };
//         } else {
//           clearInterval(this.timer);
//           return { isExpired: true };
//         }
//       });
//     }, 1000);
//   }

//   componentWillUnmount() {
//     if (this.timer) {
//       clearInterval(this.timer);
//     }
//   }
//   customStatusRender = (info) => {
//     var _a, _b, _c;
//     switch (info.status) {
//       case "expired":
//         return (
//           <div>
//             <CloseCircleFilled style={{ color: "red" }} />{" "}
//             {(_a = info.locale) === null || _a === void 0 ? void 0 : _a.expired}
//             <p>
//               <Button type="link" onClick={info.onRefresh}>
//                 <ReloadOutlined />{" "}
//                 {(_b = info.locale) === null || _b === void 0
//                   ? void 0
//                   : _b.refresh}
//               </Button>
//             </p>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };
//   // ฟังก์ชันสำหรับดาวน์โหลดรูปภาพ QR Code ที่แก้ไขแล้ว
//   handleDownloadQR = () => {
//     // เข้าถึง canvas element ผ่าน ref
//     const canvas = this.qrCodeRef.current.querySelector("canvas");
//     if (canvas) {
//       const image = canvas
//         .toDataURL("image/png")
//         .replace("image/png", "image/octet-stream");
//       const link = document.createElement("a");
//       link.href = image;
//       link.download = "qr_payment.png";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//   };

//   formatTime = (seconds) => {
//     const minutes = Math.floor(seconds / 60);
//     const remainingSeconds = seconds % 60;
//     return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
//       .toString()
//       .padStart(2, "0")}`;
//   };

//   render() {
//     const { isExpired } = this.state;
//     const qrStatus = isExpired ? "expired" : "active";
//     const {qrCodeData } = this.props;
//     console.log(qrCodeData?.full_data?.amount)
//     return (
//       <div className="qr-wrapper">
//         <div className="qr-container">
//           <>
//             <div className="qr-header">
//               ต้องโอนจากบัญชีที่เป็นสมาชิกของเราเท่านั้น
//             </div>

//             <div className="qr-box" ref={this.qrCodeRef}>
//               <QRCode
//                 value={qrCodeData?.qrCode} // ใส่ค่า QR Code ที่ต้องการ
//                 size={256}
//                 status={qrStatus}
//                 level={"H"}
//                 includeMargin={true}
//                 onRefresh={() => console.log("refresh")}
//                 statusRender={this.customStatusRender}
//               />
//               <p>{qrCodeData?.full_data?.referenceId || ''}</p>
//               <br />
//               <div className="qr-footer">
//                 <div className="qr-info-2">
//                   <div className="info-item">
//                     <img src={Logo} height={40} alt="Logo" />
//                   </div>
//                   <div className="info-item">
//                     <Button
//                       size="large"
//                       disabled={isExpired}
//                       className="download-btn "
//                       onClick={this.handleDownloadQR}
//                     >
//                     <span className="download-icon"><CloudDownloadOutlined /></span> บันทึก
//                     </Button>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="qr-footer">
//               <div className="qr-info">
//                 <div className="info-item">
//                   <div className="label">โอนเงินภายใน</div>
//                   <div
//                     className="value countdown-timer"
//                     style={{ color: qrStatus === "expired" ? "red" : "" }}
//                   >
//                     {this.formatTime(qrCodeData?.qrExpireTime || '')}
//                   </div>
//                   <div className="date">
//                     {moment(qrCodeData?.full_data?.expires_at).locale("th").format("l")}
//                   </div>
//                 </div>
//                 <div className="info-item">
//                   <div className="label">ยอดโอน</div>
//                   <div className="value amount">{Intl.NumberFormat().format(parseFloat(qrCodeData?.full_data?.transferAmount || 0).toFixed(2))}.-</div>
//                   <div className="received">ได้รับ {Intl.NumberFormat().format(parseFloat(qrCodeData?.full_data?.amount || 0).toFixed(2))}.-</div>
//                 </div>
//               </div>
//               <p>
//                 <span style={{ color: "#888" }}>Version: {config.version}</span>
//               </p>
//             </div>
//           </>
//         </div>
//       </div>
//     );
//   }
// }

// export default QRCodeComponent;
// QRCodeComponent.js
// QRCodeComponent.js (แก้ไขแล้ว)
import React, { Component } from "react";
import { Button, Divider, QRCode } from "antd";
import "./QRCodeComponent.css";
import { CloseCircleFilled, CloudDownloadOutlined, CopyOutlined, ReloadOutlined, CloseOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import moment from "moment";
import { CopyTextToClipboard } from "../helpers/copy";
import Logo from "../assets/images/logo/payeasy1.png";
import config from "../config/app.config";
import { showToast } from "../utils";
import Apibank from "../api/Apibank";

class QRCodeComponent extends Component {
  constructor(props) {
    super(props);
    const { qrCodeData } = props;
    const initialTimeLeft = qrCodeData?.qrExpireTime
      ? Math.floor((qrCodeData.qrExpireTime - moment().valueOf()) / 1000)
      : 0;

    this.state = {
      timeLeft: initialTimeLeft > 0 ? initialTimeLeft : 0,
      isExpired: initialTimeLeft <= 0,
    };
    this.timer = null;
    this.qrCodeRef = React.createRef();
  }

  componentDidMount() {
    const { getDataBankAccount } = this.props;
    // เริ่มตัวนับเวลาถอยหลัง
    if (this.state.timeLeft > 0) {
      this.timer = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.timeLeft > 1) {
            return { timeLeft: prevState.timeLeft - 1 };
          } else {
            getDataBankAccount()
            clearInterval(this.timer);
            return { isExpired: true, timeLeft: 0 };
          }
        });
      }, 1000);
    }
  }

  componentWillUnmount() {
    // หยุดตัวนับเวลาเมื่อ component ถูก unmount
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  // ใช้ getDerivedStateFromProps เพื่อ reset state เมื่อ props เปลี่ยน
  static getDerivedStateFromProps(nextProps, prevState) {
    const { qrCodeData } = nextProps;
    if (qrCodeData?.qrExpireTime !== prevState.qrCodeData?.qrExpireTime) {
      const initialTimeLeft = qrCodeData?.qrExpireTime
        ? Math.floor((qrCodeData.qrExpireTime - moment().valueOf()) / 1000)
        : 0;
      return {
        timeLeft: initialTimeLeft > 0 ? initialTimeLeft : 0,
        isExpired: initialTimeLeft <= 0,
        qrCodeData: qrCodeData, // เก็บ props ไว้ใน state เพื่อใช้ในการเปรียบเทียบครั้งถัดไป
      };
    }
    return null;
  }

  customStatusRender = (info) => {
    const { handleShowPaymentModel } = this.props;
    switch (info.status) {
      case "expired":
        return (
          <div>
            <CloseCircleFilled style={{ color: "red" }} /> หมดอายุแล้ว
            <p>
              <Button type="link" onClick={handleShowPaymentModel}>
                <ReloadOutlined /> สร้างใหม่
              </Button>
            </p>
          </div>
        );
      default:
        return null;
    }
  };

  handleDownloadQR = () => {
    const canvas = this.qrCodeRef.current.querySelector("canvas");
    const { qrCodeData } = this.props;
    if (canvas) {
      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = image;
      link.download = `${qrCodeData.qrExpireTime}_qr_payment.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  formatTime = (seconds) => {
    if (seconds < 0) {
      return "00:00";
    }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

   handleConfirmTransfer = async() => {
      this.setState({ loading: true });
      try {
        const res = await Apibank.getConfirmTransfer();
        if (res.data.success) {
          showToast("success", "ทำรายการให้สำเร็จ");
          setTimeout(() => {
            this.props.handleCloseQrcode()
          }, 1500);
        } else {
          showToast("error", "เกิดข้อผิดพลาดทำรายการใหม่ภายหลัง");
        }
      } catch (error) {
        showToast("error", error.message);
      }
    }
  render() {
    const { timeLeft, isExpired } = this.state;
    const { qrCodeData, handleCloseQrcode } = this.props;
    const qrStatus = isExpired ? "expired" : "active";

    return (
      <>
        <div id="qrCode" className="qr-wrapper mb-5">
          <div className="qr-container">
            <Divider orientation="right">
              <Button onClick={handleCloseQrcode} shape="circle" icon={<CloseOutlined  />} />
            </Divider>
            <>
              <div className="qr-header"><h4>! สแกนได้แค่ครั้งเดียว</h4></div>
                <div className="qr-header"  style={{color: "#dc5a4c"}} >ต้องโอนจากบัญชีที่เป็นสมาชิกของเราเท่านั้น</div>
              <div className="qr-box"ref={this.qrCodeRef}>
                <QRCode
                  value={qrCodeData?.qrCode || ""}
                  size={256}
                  status={qrStatus}
                  level={"H"}
                  includeMargin={true}
                  statusRender={this.customStatusRender}
                />
                <p style={{fontSize:"12px"}}>{qrCodeData?.uuid || ""} <span><CopyOutlined onClick={() => CopyTextToClipboard(qrCodeData?.uuid)} style={{ cursor: "copy" }} /></span></p>
                <br />
                <div className="qr-footer">
                  <div className="qr-info-2">
                    <div className="info-item">
                      <img src={Logo} height={40} alt="Logo" />
                    </div>
                    <div className="info-item">
                      <Button
                        size="large"
                        disabled={isExpired}
                        className="download-btn"
                        onClick={this.handleDownloadQR}
                      >
                        <span className="download-icon"><CloudDownloadOutlined /></span> บันทึก
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="qr-footer">
                <div className="qr-info">
                  <div className="info-item">
                    <div className="label">โอนเงินภายใน</div>
                    <div
                      className="value countdown-timer"
                      style={{ color: qrStatus === "expired" ? "red" : "" }}
                    >
                      {this.formatTime(timeLeft)}
                    </div>
                    <div className="date">
                      {moment(qrCodeData?.full_data?.expires_at).locale("th").format("l")}
                    </div>
                  </div>
                  <div className="info-item">
                    <div className="label">ยอดโอน</div>
                    <div className="value amount">{Intl.NumberFormat().format(parseFloat(qrCodeData?.full_data?.amount || 0).toFixed(2))}.-</div>
                    <div className="received">ได้รับ {Intl.NumberFormat().format(parseFloat(qrCodeData?.full_data?.amount || 0).toFixed(2))}.-</div>
                  </div>
                </div>
                <Button type="primary" children={'โอนสำเร็จ'} onClick={handleCloseQrcode}  icon={<SafetyCertificateOutlined />} />
                <p>
                  <span style={{ color: "#888" }}>Version: {config.version}</span>
                </p>
              </div>
            </>
          </div>
        </div>
      </>
    );
  }
}

export default QRCodeComponent;